import { selectScid } from 'store/college'
import { useSelector } from 'react-redux'

export default () => useSelector(selectScid)
export const useGuarenteedScid = () => {
  const scid = useSelector(selectScid)
  if (!scid) throw new Error('No scid found')
  return scid
}
